export default __webpack_public_path__ + "denied-icon.svg";